import { CurrencyPercentageInput as AntdCurrencyPercentageInput } from "@empglabs/backoffice-ui-kit"

const CurrencyPercentageInput = props => {
  return <AntdCurrencyPercentageInput {...props} />
}

export default CurrencyPercentageInput
